import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { isDefined } from '@morpho-org/morpho-ts';
import { memo } from 'react';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
interface VaultV2PendingTimelockChangeForceDeallocatePenaltyProps {
  currentValue?: bigint;
  newValue: BigIntish;
  functionName: string;
}
const VaultV2PendingTimelockChangeForceDeallocatePenalty = t0 => {
  const $ = _c(18);
  const {
    currentValue,
    newValue,
    functionName
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    label,
    criticality
  } = t1;
  let t2;
  if ($[2] !== criticality || $[3] !== label) {
    t2 = <VaultPendingTimelockHeader title={label} criticality={criticality} />;
    $[2] = criticality;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentValue) {
    t3 = isDefined(currentValue) && <StyledVaultPendingTimelock.Row><span className="text-2xs text-foreground">Initial value</span><span className="text-2xs text-foreground">{currentValue}</span></StyledVaultPendingTimelock.Row>;
    $[5] = currentValue;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = isDefined(currentValue) ? "New value" : "Value";
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="text-2xs text-foreground">{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== newValue) {
    t6 = <span className="text-2xs text-foreground">{newValue}</span>;
    $[9] = newValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <StyledVaultPendingTimelock.Row>{t5}{t6}</StyledVaultPendingTimelock.Row>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t7) {
    t8 = <div className="flex flex-col">{t2}{t3}{t7}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default memo(VaultV2PendingTimelockChangeForceDeallocatePenalty);